//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 288,
                    y: 210,
                    scale: 1.5
                },
                {
                    x: 695,
                    y: 270,
                    scale: 1.5
                },
                {
                    x: 78,
                    y: 408,
                    scale: 1.5
                },
                {
                    x: 460,
                    y: 533,
                    scale: 1.5
                },
                {
                    x: 150,
                    y: 595,
                    scale: 1.5
                },
            ]
        };
    }
};
